import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import banner5 from "../assets/banner5.jpg";
import { IoMdArrowDropright } from "react-icons/io";

export default function HomeBanner3() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  const values = [
    "Innovation through practical technology",
    "Integrity in every decision and delivery",
    "Customer-first thinking in every solution",
    "Consistent excellence across execution",
  ];

  const approachPoints = [
    "Understand business needs before proposing technology",
    "Design solutions that improve real operations",
    "Implement with clarity and minimal disruption",
    "Support systems for long-term growth",
  ];

  useEffect(() => setReady(true), []);

  if (!ready) {
    return (
      <div className="flex items-center justify-center h-[60vh]">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <>
      <style>{`
        .tech-section-clean {
          position: relative;
          padding: 6rem 1.5rem;
          color: #e2e8f0;
          overflow: hidden;
        }

        /* Background */
        .tech-bg {
          position: absolute;
          inset: 0;
          z-index: 0;
        }

        .tech-bg img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transform: scale(1.05);
        }

        /* Overlay */
        .tech-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            135deg,
            rgba(2,6,23,0.92),
            rgba(2,6,23,0.85),
            rgba(2,6,23,0.9)
          );
          z-index: 1;
        }

        .tech-container {
          position: relative;
          z-index: 1;
          max-width: 1100px;
          margin: 0 auto;
        }

        .tech-header {
          text-align: center;
          max-width: 700px;
          margin: 0 auto 4rem;
        }

        .tech-eyebrow {
          font-size: 0.75rem;
          letter-spacing: 0.15em;
          color: #94a3b8;
          text-transform: uppercase;
        }

        .tech-title {
          font-size: 2.5rem;
          font-weight: 700;
          color: #fff;
          margin: 1rem 0;
        }

        .tech-copy {
          color: #94a3b8;
          font-size: 1rem;
        }

        /* Values */
        .tech-values {
          display: grid;
          grid-template-columns: 1fr;
          gap: 1rem;
          margin-bottom: 4rem;
        }

        @media (min-width: 768px) {
          .tech-values {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        .tech-value-item {
          padding: 1rem 1.2rem;
          border-left: 2px solid #3b82f6;
          background: rgba(255,255,255,0.03);
          font-size: 0.95rem;
          color: #cbd5e1;
        }

        /* Approach */
        .tech-approach {
          display: grid;
          gap: 2rem;
        }

        @media (min-width: 768px) {
          .tech-approach {
            grid-template-columns: 1fr 1fr;
            align-items: center;
          }
        }

        .tech-approach h3 {
          color: #fff;
          margin-bottom: 1rem;
        }

        .tech-approach p {
          color: #94a3b8;
        }

        .tech-steps {
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }

        .tech-step {
          display: flex;
          gap: 1rem;
          font-size: 0.9rem;
          color: #cbd5e1;
        }

        .tech-step span {
          color: #3b82f6;
          font-weight: 600;
        }

        /* CTA */
        .tech-btn {
          margin-top: 1.5rem;
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.8rem 1.4rem;
          border-radius: 999px;
          background: #c9bc08;
          border: none;
          color: #fff;
          cursor: pointer;
          transition: 0.3s ease;
        }

        .tech-btn:hover {
          background: #1d4ed8;
          transform: translateY(-2px);
        }
      `}</style>

      <section className="tech-section-clean">
        {/* Background */}
        <div className="tech-bg">
          <img src={banner5} alt="" />
        </div>
        <div className="tech-overlay"></div>

        <div className="tech-container p-3 p-md-5">
          {/* Header */}
          <div className="tech-header">
            <h1 className="text-primary font-bold">
              Built on clarity, reliability, and continuous improvement.
            </h1>
            <p className="tech-copy">
              We align technology with real business needs, ensuring every system
              delivers measurable value and long-term stability.
            </p>
          </div>

          {/* Values */}
          <div className="tech-values">
            {values.map((v) => (
              <div key={v} className="tech-value-item">
                {v}
              </div>
            ))}
          </div>

          {/* Approach */}
          <div className="tech-approach">
            <div>
              <h3>Our Approach</h3>
              <p>
                A structured, practical process designed to deliver technology
                that works reliably in real environments.
              </p>

              <button
                className="tech-btn"
                onClick={() => appContext.navTo({ item: "contact_us" })}
              >
                Work With Us
                <IoMdArrowDropright size={20} />
              </button>
            </div>

            <div className="tech-steps">
              {approachPoints.map((p, i) => (
                <div key={p} className="tech-step">
                  <span>0{i + 1}</span>
                  <div>{p}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}